import { passiveCoefficient } from "./coefficients";

export interface PassiveInput { enabled: boolean; Df: number; neglectedDepth: number; gamma: number; phi: number; c: number; theta: number; hwFront: number; gw: number }

/**
 * Ön pasif direnç (karakteristik). Kp: TBDY Denk. 16.25 (ψ=90°, β=0, δ=0).
 * Rpk = ½·Kp·γ·Dp² + 2c√Kp·Dp ; ön su seviyesi altındaki kısım γ' ile (kısmi batıklıkta derinlik ağırlıklı ortalama).
 */
export function passiveResistance(p: PassiveInput): { Rpk: number; Kp: number; Dp: number; y: number } {
  const Dp = Math.max(0, p.Df - p.neglectedDepth);
  if (!p.enabled || Dp <= 0) return { Rpk: 0, Kp: 0, Dp, y: 0 };
  const Kp = passiveCoefficient({ phi: p.phi, beta: 0, psi: Math.PI / 2, theta: p.theta });
  const hSub = Math.min(Math.max(0, p.hwFront), Dp);
  const gammaEq = ((p.gamma * (Dp - hSub)) + (p.gamma - p.gw) * hSub) / Dp;
  const Rpk = 0.5 * Kp * gammaEq * Dp * Dp + 2 * p.c * Math.sqrt(Kp) * Dp;
  return { Rpk, Kp, Dp, y: Dp / 3 };
}
